import { render } from "./PrivacyPage.vue?vue&type=template&id=550a6620"
const script = {}

import "./PrivacyPage.vue?vue&type=style&index=0&id=550a6620&lang=css"

import exportComponent from "/var/jenkins_home/jobs/ohm-landing/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__